module.exports = __webpack_public_path__ + "img/26.c3e6aae8.jpg";